import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AuthService } from '@auth/auth-service';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap/dropdown';

@Component({
  selector: 'abc-user-dropdown',
  templateUrl: 'user-dropdown.html',
  imports: [NgbDropdownModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserDropdown {
  private readonly authService = inject(AuthService);

  protected readonly userName = this.authService.userName;

  protected readonly isImpersonating = this.authService.isImpersonating;
  protected readonly impersonatedUser = this.authService.impersonatedUser;

  logout() {
    this.authService.logout();
  }

  stopImpersonating(): void {
    this.authService.stopImpersonating();
  }
}
